import { Box, Container, Typography, CircularProgress, useTheme, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import Lottie from "lottie-react";
import maintenanceAnimation from "../assets/animations/maintenance.json";

// Styled components
const MaintenanceWrapper = styled(Box)(({ theme }) => ({
//   minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: theme.palette.background.default,
  padding: theme.spacing(2),
}));

const ContentBox = styled(Box)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(4),
  maxWidth: 800,
  width: "100%",

}));

const LogoBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  "& img": {
    maxWidth: 200,
    height: "auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: 150,
    },
  },
}));

const AnimationBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(4, 0),
  height: {
    xs: 300, // height for mobile devices
    sm: 400, // height for tablets
    md: 500, // height for desktop
  },
  width: "100%",
  maxWidth: 500,
  margin: "0 auto",
  "& > div": {
    height: "100%",
    width: "100%",
  },
}));

const MaintenancePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <MaintenanceWrapper>
      <Container maxWidth="md">
        <ContentBox>


          <Typography
            variant={isMobile ? "h4" : "h3"}
            gutterBottom
            color="primary"
            sx={{ fontWeight: "bold" }}
          >
            Site Under Maintenance
          </Typography>

          <Typography
            variant={isMobile ? "h6" : "h5"}
            gutterBottom
            color="text.secondary"
          >
            Sainik School Ghorakhal, OBA
          </Typography>

          <AnimationBox>
            <Lottie
              animationData={maintenanceAnimation}
              loop={true}
              style={{ width: "100%", height: "100%" }}
            />
          </AnimationBox>

          <Typography
            variant="body1"
            color="text.secondary"
            paragraph
            sx={{
              fontSize: isMobile ? "1rem" : "1.1rem",
              maxWidth: "600px",
              margin: "0 auto"
            }}
          >
            Our team is working hard to improve your experience.
            Please check back soon.
          </Typography>



          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: isMobile ? "0.875rem" : "1rem",
              fontWeight: "medium"
            }}
          >
            Expected completion time: 2-3 hours
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              mt: 2,
              fontSize: isMobile ? "0.875rem" : "1rem"
            }}
          >
            For urgent inquiries, please contact:{" "}
            <Box
              component="span"
              sx={{
                color: "primary.main",
                fontWeight: "medium"
              }}
            >
              support@sainikschoolghorakkhaloba.org
            </Box>
          </Typography>
        </ContentBox>
      </Container>
    </MaintenanceWrapper>
  );
};

export default MaintenancePage;
